import { render, staticRenderFns } from "./PreviewReply.vue?vue&type=template&id=159285fc&scoped=true&"
import script from "./PreviewReply.vue?vue&type=script&lang=js&"
export * from "./PreviewReply.vue?vue&type=script&lang=js&"
import style0 from "./PreviewReply.vue?vue&type=style&index=0&id=159285fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159285fc",
  null
  
)

export default component.exports